.logo {
  display: inline-flex;
  align-items: center;
  gap: 11px;
}

.words {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

/*
 * Цвет задаётся один на все части: контуры залиты currentColor, поэтому
 * знак и надписи перекрашиваются вместе с темой. Градиент «под металл»
 * потребовал бы ссылок на общий <defs> из трёх разных SVG — связь по id
 * между ними работает не везде и ломается при переносе компонента.
 */
.silver,
.name,
.sub {
  color: #ededed;
}

/* Ширина задаётся, высота следует пропорции контура. */
.name {
  width: 124px;
  height: auto;
}

.sub {
  width: 52px;
  height: auto;
}
